import { render, staticRenderFns } from "./ListAtivacoes.vue?vue&type=template&id=06ea120d"
import script from "./ListAtivacoes.vue?vue&type=script&lang=js"
export * from "./ListAtivacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports